/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actiontodaydone2Inputs */

const en_actiontodaydone2 = /** @type {(inputs: Actiontodaydone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You already sent an action today. The next one is possible tomorrow.`)
};

const de_actiontodaydone2 = /** @type {(inputs: Actiontodaydone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heute hast du schon eine Aktion geschaltet. Die nächste geht ab morgen.`)
};

/**
* | output |
* | --- |
* | "You already sent an action today. The next one is possible tomorrow." |
*
* @param {Actiontodaydone2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actiontodaydone2 = /** @type {((inputs?: Actiontodaydone2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actiontodaydone2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actiontodaydone2(inputs)
	return de_actiontodaydone2(inputs)
});
export { actiontodaydone2 as "actionTodayDone" }